import React from "react";
import { defaultTheme as theme } from "@deliverr/ui/lib-esm/shared/theme";
import { SideBar } from "./SideBar";
import styled from "@emotion/styled";

export const StyledTitle = styled.td`
  width: 100px;
  background-color: ${theme.colors.BLUE[600]};
  color: white;
  font-family: ${theme.font.family.STANDARD};
  font-size: ${theme.font.size.F2};
  font-weight: ${theme.font.weight.BOLD};
  text-align: center;
  padding: ${theme.spacing.S3};
`;

export const Page: React.FC<{ content: any; title: string }> = ({
  content,
  title,
}) => {
  return (
    <table width="100%">
      <tr>
        <StyledTitle colSpan={2} align="center">
          {title}
        </StyledTitle>
      </tr>
      <tr>
        <SideBar />
        <td>{content()}</td>
      </tr>
    </table>
  );
};
